module.exports = __webpack_public_path__ + "static/media/river_311x110.952ad2e9.jpg";